import styled from 'styled-components';
import { devices } from '@/UI/Styles';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: ${({ theme }) => theme.spacing[8]};
`;

export const CheckboxBox = styled.span`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 1px;

  @media ${devices.XLarge} {
    margin-top: 2px;
  }

  .check {
    position: absolute;
    top: 1px;
    left: 1px;
    pointer-events: none;
  }
`;

export const Input = styled.input`
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
  width: 18px;
  height: 18px;
  border: 1px solid ${({ theme }) => theme.migrateColors('border.inputDefault', 'gray')};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.migrateColors('background.primary', 'white')};
  cursor: pointer;
  transition: background-color 150ms, border-color 150ms;

  &:checked {
    background-color: ${({ theme }) => theme.brandTheme.brand100};
    border-color: ${({ theme }) => theme.brandTheme.brand100};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.brandTheme.brand50};
    outline-offset: 2px;
  }
`;

export const Label = styled.label`
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: ${({ theme }) => theme.fontWeight.light};
  font-size: ${({ theme }) => theme.fontSize['small-mobile']};
  line-height: 18px;
  color: ${({ theme }) => theme.migrateColors('text.subtler', 'gray80')};

  @media ${devices.XLarge} {
    font-size: ${({ theme }) => theme.fontSize['small-desktop']};
    line-height: 21px;
  }
`;

export const PolicyLink = styled.a`
  color: ${({ theme }) => theme.brandTheme.brand100};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
